import favoriteQuery from './favorite-query.action';

export default favoriteQuery;
